import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/career.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Join Our Team"
				subtitle=""
				breadcrumbText="Careers"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}